import { styled } from '@mui/material/styles';
import Link from '@mui/material/Link';

export const StyledLink = styled(Link)(({ color, underline, theme }) => ({
  ':hover': {
    color: color === 'primary' && underline === 'none' ? theme.palette.primary.dark : color,
  },
}));
